module.exports = __webpack_public_path__ + "img/andoid.a9adf60d.svg";